// extracted by mini-css-extract-plugin
export default {"burger":"burgers_burger__gcHhL"};